export enum ElectricalSections {
    TrippingCurrent = "trippingCurrent"
}